import { FC } from 'react';
import logo from '@assets/images/header/parrot-logo.svg';
import styles from './parrot-loading.module.scss';

const ParrotLoading: FC = () => {
  return (
    <div className={styles.loading}>
      <img src={logo} />
    </div>
  );
};

export default ParrotLoading;
